import { render, staticRenderFns } from "./ProjectsPanelInformationalMessage.vue?vue&type=template&id=047c2269&"
import script from "./ProjectsPanelInformationalMessage.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanelInformationalMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports